/**
 * This date-fns token represents a Date in year-month-day with padded zeroes so that it can be used
 * in the Database for sorting like {date: -1} or filtering like {date: {$gte: '2021-01-01'}}
 */
export const dbDayDateToken = 'yyyy-MM-dd';
